
import React from 'react';
import { Search, Bell, ChevronDown } from 'lucide-react';
import { Button } from 'app/components/ui/button';
import { Input } from 'app/components/ui/input';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'app/components/ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from 'app/components/ui/avatar';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from 'app/slice/selectors';
import { useGlobalSlice } from 'app/slice';
import { useNavigate } from 'react-router-dom';

export function Header() {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { actions } = useGlobalSlice();

    const handleLogout = () => {
        dispatch(actions.logout());
        navigate("/login");
    };

    const getInitials = (firstName?: string, lastName?: string) => {
        return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
    };

    return (
        <header className="sticky top-0 z-50 w-full h-[64px] bg-white border-b border-gray-200 shadow-sm">
            <div className="flex h-16 items-center px-6 justify-between">
                {/* Logo Section */}
                <div className="flex items-center gap-3 w-[260px] flex-shrink-0">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgb(146, 38, 213)' }}>
                        <span className="text-white font-bold text-lg">Z</span>
                    </div>
                    <span className="text-xl font-bold text-gray-900 tracking-tight font-sans">Zieny</span>
                </div>

                {/* Search Section */}
                {/* <div className="flex-1 flex justify-center px-4">
                    <div className="relative w-full max-w-[600px]">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <Input
                            placeholder="Search products..."
                            className="pl-10 bg-gray-50 border border-gray-200 shadow-sm h-10 rounded-lg w-full focus-visible:ring-offset-0 focus-visible:ring-[#8B5CF6]"
                            style={{
                                fontSize: '14px',
                                color: '#6B7280'
                            }}
                        />
                    </div>
                </div> */}

                {/* Right Section */}
                <div className="flex items-center gap-4 flex-shrink-0 w-[260px] justify-end">
                    {/* User Profile */}
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="ghost" className="flex items-center gap-3 hover:bg-gray-50 pl-2 pr-2 rounded-full border border-transparent hover:border-gray-200 transition-all">
                                <Avatar className="h-8 w-8 border border-gray-200">
                                    <AvatarImage src={user?.profilePicture} />
                                    <AvatarFallback className="bg-[#FF6B6B] text-white text-xs">
                                        {getInitials(user?.firstName, user?.lastName)}
                                    </AvatarFallback>
                                </Avatar>
                                <div className="flex items-center gap-2 hidden md:flex">
                                    <span className="text-sm font-medium text-gray-700">
                                        {user?.firstName} {user?.lastName}
                                    </span>
                                    <ChevronDown className="h-4 w-4 text-gray-400" />
                                </div>
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="w-56 mt-2">
                            {/* <DropdownMenuLabel>My Account</DropdownMenuLabel> */}
                            {/* <DropdownMenuSeparator /> */}
                            <DropdownMenuItem onClick={() => navigate('/admin/profile-settings')}>
                                Settings
                            </DropdownMenuItem>
                            {/* <DropdownMenuItem>Billing</DropdownMenuItem> */}
                            {/* <DropdownMenuItem>Team</DropdownMenuItem> */}
                            <DropdownMenuSeparator />
                            <DropdownMenuItem onClick={handleLogout} className="text-red-600">
                                Log out
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            </div>
        </header>
    );
}
